import {
  ReadFirmwareGroupsReportRequest,
  ReadDeploymentProgressReportRequest,
  ReadDeviceCounterOverTimeReportRequest,
  ReadDeviceReportRequest,
  ReadDevicesByWeekReportRequest,
  ReadIncorrectRequestsReportRequest,
  ReadFirmwareGroupByStbGroupIdReportRequest,
  ReadFirmwareGroupEntryByStbGroupIdReportRequest,
  FirmwareGroupsByStbGroupExportCsvRequest,
  GetNumberRegisteredDevicesRequest,
  GetNumberActiveDevicesRequest,
  ReadNotEmptyStbGroupsRequest,
} from '@openapi';
import { getDashboards, getReportsApi, getStbGroupsApi } from './configuration';

const reports = {
  getActiveDevicesReport: (requestParameters?: GetNumberActiveDevicesRequest) => {
    return getDashboards().getNumberActiveDevices(requestParameters);
  },
  getRegisteredDevicesReport: (requestParameters?: GetNumberRegisteredDevicesRequest) => {
    return getDashboards().getNumberRegisteredDevices(requestParameters);
  },
  getReport: (requestParameters?: ReadDeviceReportRequest) => {
    return getReportsApi().readDeviceReport(requestParameters);
  },
  getReportByWeek: (requestParameters: ReadDevicesByWeekReportRequest) => {
    return getReportsApi()
      .readDevicesByWeekReport(requestParameters)
      .then(({ elements }) => elements);
  },

  //dashboards
  getDeviceConnect: () => {
    return getReportsApi().readDeviceConnectionCountersReport();
  },

  getDeviceReq: () => {
    return getReportsApi().readIncorrectRequestsSummaryReport();
  },

  getIncorrectRequestsReport: (requestParameters: ReadIncorrectRequestsReportRequest) => {
    return getReportsApi().readIncorrectRequestsReport(requestParameters);
  },

  getStbReportNoEmpty: (req?: ReadNotEmptyStbGroupsRequest) => {
    return getStbGroupsApi().readNotEmptyStbGroups({ filterDeviceTypeId: req?.filterDeviceTypeId });
  },

  getDeviceNumber: (requestParameters: ReadDeviceCounterOverTimeReportRequest) => {
    return getReportsApi().readDeviceCounterOverTimeReport({
      deviceTypeId: requestParameters.deviceTypeId,
      nbTotal: requestParameters.nbTotal,
    });
  },

  getDeviceTotal: () => {
    return getReportsApi()
      .readDeviceCountersReport()
      .then(({ elements }) => elements);
  },

  getAllDevicesCounter: () => {
    return getReportsApi().readAllDevicesCounterOverTimeReport();
  },

  getDeployChart: (requestParameters: ReadDeploymentProgressReportRequest) => {
    return getReportsApi().readDeploymentProgressReport({ stbGroupId: requestParameters?.stbGroupId });
  },
  getFirmwareReport: (stbGroupId: ReadFirmwareGroupsReportRequest['stbGroupId']) => {
    return getReportsApi().readFirmwareGroupsReport({ stbGroupId });
  },

  //GroupMap

  getGroupMap: (requestParameters: ReadFirmwareGroupByStbGroupIdReportRequest) => {
    return getReportsApi().readFirmwareGroupByStbGroupIdReport({ stbGroupId: requestParameters?.stbGroupId });
  },

  connectColumn: (requestParameters: ReadFirmwareGroupEntryByStbGroupIdReportRequest) => {
    return getReportsApi().readFirmwareGroupEntryByStbGroupIdReport(requestParameters);
  },
  getExportFileGroup: (requestParameters: FirmwareGroupsByStbGroupExportCsvRequest) => {
    return getReportsApi().firmwareGroupsByStbGroupExportCsv({
      stbGroupId: requestParameters?.stbGroupId,
      deviceTypeId: requestParameters?.deviceTypeId,
    });
  },
};

export default reports;
